// Alert Component

import React, { useEffect, useRef } from 'react';
import { FiAlertCircle, FiCheckCircle, FiXCircle, FiInfo, FiX } from 'react-icons/fi';

// Toast-style alerts (anything with onClose) auto-dismiss after `duration` ms
// so a stray success/error message doesn't sit on screen until someone clicks
// the X. Pass duration={0} to opt out. Alerts without onClose are treated as
// persistent inline form errors and are never auto-dismissed.
const Alert = ({ type = 'info', message, onClose, className = '', duration = 5000 }) => {
  const onCloseRef = useRef(onClose);
  useEffect(() => { onCloseRef.current = onClose; }, [onClose]);

  useEffect(() => {
    if (!onClose || !duration) return undefined;
    const timer = setTimeout(() => onCloseRef.current?.(), duration);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, duration]);

  const styles = {
    success: { wrap: 'bg-emerald-50 border-emerald-200 text-emerald-800', icon: <FiCheckCircle className="w-4 h-4 text-emerald-600 shrink-0" /> },
    error:   { wrap: 'bg-rose-50 border-rose-200 text-rose-800',         icon: <FiXCircle    className="w-4 h-4 text-rose-600 shrink-0" /> },
    warning: { wrap: 'bg-amber-50 border-amber-200 text-amber-800',      icon: <FiAlertCircle className="w-4 h-4 text-amber-600 shrink-0" /> },
    info:    { wrap: 'bg-blue-50 border-blue-200 text-blue-800',         icon: <FiInfo        className="w-4 h-4 text-blue-600 shrink-0" /> },
  };

  const s = styles[type];

  return (
    <div className={`flex items-start gap-3 border rounded-xl px-4 py-3 text-sm animate-fade-in-up ${s.wrap} ${className}`}>
      <div className="pt-0.5">{s.icon}</div>
      <p className="flex-1 font-medium leading-snug">{message}</p>
      {onClose && (
        <button onClick={onClose} className="opacity-50 hover:opacity-100 transition-opacity shrink-0">
          <FiX className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default Alert;
